module.exports = __webpack_public_path__ + "static/tuzagInside-4921a5bc009eb5c5ef497bcdf26d4a70.svg";